﻿import {Ref, ref, watch} from "vue";

export const useQuery = (query: Ref, defaultQuery?: () => any) => {

    const _query = ref();
    watch(query, newQuery =>
        _query.value = {
            ...defaultQuery?.(),
            ...newQuery,
            $start: Object.keys(newQuery).length > 0,
        }, {immediate: true});

    return {
        query: _query
    }
}